import { useMediaQuery } from "@histoire/vendors/vue-use";
const isMobile = useMediaQuery("(max-width: 640px)");
export {
  isMobile
};
